import { TextFieldProps } from '@mui/material';
import { MHMTextField } from './MHMTextField';

export type MHMNumberInputProps = TextFieldProps & {
  allowDecimal?: boolean;
};

export function MHMNumberInput(props: MHMNumberInputProps) {
  const { allowDecimal, slotProps, ...rest } = props;
  const { htmlInput, ...restSlotProps } = slotProps || {};

  return (
    <MHMTextField
      slotProps={{
        htmlInput: {
          inputMode: allowDecimal ? 'decimal' : 'numeric',
          pattern: allowDecimal ? '[0-9]*\\.?[0-9]*' : '[0-9]*',
          ...htmlInput,
        },
        ...restSlotProps,
      }}
      {...rest}
    />
  );
}
